import { format, isValid, parse, parseISO } from "date-fns";
import { enUS, fr } from "date-fns/locale";

export function parseResumeDate( dateValue ) {
    if ( dateValue instanceof Date ) {
        return isValid( dateValue ) ? dateValue : null;
    }

    if ( typeof dateValue === 'number' ) {
        const date = new Date( dateValue );
        return isValid( date ) ? date : null;
    }

    if ( typeof dateValue !== 'string' || !dateValue.trim() ) {
        return null;
    }

    const value = dateValue.trim();
    const isoDate = parseISO( value );
    if ( isValid( isoDate ) ) {
        return isoDate;
    }

    const supportedFormats = [ 'MM/yyyy', 'M/yyyy', 'MM-yyyy', 'M-yyyy', 'dd/MM/yyyy', 'd/M/yyyy' ];
    for ( const supportedFormat of supportedFormats ) {
        const parsedDate = parse( value, supportedFormat, new Date( 2000, 0, 1 ) );
        if ( isValid( parsedDate ) ) {
            return parsedDate;
        }
    }

    return null;
}

export function formatDate( dateString, language = 'fr' ) {
    const date = parseResumeDate( dateString );
    if ( !date ) {
        return '';
    }
    const locale = language === 'en' ? enUS : fr;
    return format( date, "MM/yyyy", { locale: locale } );
}

export function formatDateCssf( dateString, language = 'fr' ) {
    const date = parseResumeDate( dateString );
    if ( !date ) {
        return '';
    }
    const locale = language === 'en' ? enUS : fr;
    return format( date, "MMM-yyyy", { locale: locale } )
        .replace( ".", "" )
        .toLowerCase();
}
